export default __webpack_public_path__ + "static/media/imageOne.393ffedd.png";